import React from "react";
import { FaMapMarker } from "react-icons/fa";

import { getContrastColor } from "utils/utils";
import { getFirstLastInterval } from "utils/datetime";
import { getStaffingAssignmentIntervals } from "components/Plans/planStaffingNeedsUtils";

/**
 * Celda izquierda (sticky) con el nombre de la necesidad, su ubicación y el
 * intervalo del turno. Reutilizada por las tablas de necesidades.
 */
const NeedNameCell = ({ assignment, showInterval = true }) => {
	const fun = assignment.function;
	const shift = assignment.shift;
	const intervals = getStaffingAssignmentIntervals(assignment);
	const needName = shift
		? `${fun.name} en ${shift.name}`
		: fun.name;

	let ubicationNode = null;
	if (assignment.ubication) {
		const ubication = assignment.ubication;
		let color;
		if (ubication.border_color) color = ubication.border_color;
		if (ubication.background_color) color = ubication.background_color;

		ubicationNode = (
			<span className="need-ubication">
				<FaMapMarker style={{ color: color && color, marginRight: "2px" }} />{" "}
				{ubication.name}
			</span>
		);
	}

	return (
		<th className="main-col-needs">
			<div
				className="th-wrap main-col-needs-box"
				style={
					shift
						? {
								backgroundColor:
									shift.background_color && shift.background_color,
								borderColor: shift.border_color && shift.border_color,
								color: getContrastColor(shift.background_color),
						  }
						: {
								backgroundColor: "#ece9fe",
								borderColor: "#d9d4fe",
								color: "#0d0a2c",
						  }
				}
			>
				<div title={needName} className="need-name substring">
					{needName}
				</div>
				<div className="need-footer">
					{ubicationNode}{" "}
					{showInterval && (
						<span className="need-interval">
							{getFirstLastInterval(intervals)}
						</span>
					)}
				</div>
			</div>
		</th>
	);
};

export default NeedNameCell;
